import { useState, useEffect, useContext, useRef } from 'react';

import { requestApi } from '../../../../util/utility';
import { cmnContext } from '../../../common/CmnContext';
import { SaleListContext } from '../SaleListContext';
import { SaleListDetailMovieThumb } from './movieThumb/SaleListDetailMovieThumb';
import { SaleLabel } from '../label/SaleLabel';
import { SaleListDetailInstructor } from './instructor/SaleListDetailInstructor';
import { SaleDetailFavorite } from './favorite/SaleDetailFavorite';
import { SaleDetailBenefit } from './benefit/SaleDetailBenefit';
import { SaleListDetailSeries } from './series/SaleListDetailSeries';
import { SaleListDetailExplane } from './explane/SaleListDetailExplane';
import { SaleListDetailPurchase } from './purchase/SaleListDetailPurchase';


export function SaleListDetailModal(props: any) {

  const sale = props.detailSale;
  const modalHeight = props.modalHeight;

  const isPc = useContext(cmnContext).isPc;
  const backgroundColor = useContext(SaleListContext).backgroundColor;
  // クリックカウント済み
  const clickedIdList = useContext(SaleListContext).clickedIdList;
  const setClickedIdList = useContext(SaleListContext).setClickedIdList;

  const modalRef = useRef<HTMLDivElement>(null);

  const [available, setAvailable] = useState<boolean>(false);

  // シリーズ対応
  const [isSeries, setIsSeries] = useState<boolean>(false);
  const [dispIndex, setDispIndex] = useState<number>(0);
  const [movieList, setMovieList] = useState<string[]>([]);
  const [saleImageList, setSaleImageList] = useState<string[]>([]);
  const [movieTitleList, setMovieTitleList] = useState<string[]>([]);
  const [movieTimeList, setMovieTimeList] = useState<string[]>([]);
  // シリーズタイトル
  const [seriesTitle, setSeriesTitle] = useState<string>('');

  const [createdAt, setCreatedAt] = useState<string>('');


  // 閲覧判定 / シリーズ対応 / クリックカウント
  useEffect(() => {
    // 閲覧可否(動画リンクで判定)
    if(sale?.download_link) {
      setAvailable(true);
    } else {
      setAvailable(false);
    }

    // シリーズ対応
    setIsSeries(sale?.movie_amount > 1);
    if(sale?.download_link) {
      setMovieList(sale.download_link.split(','));
    }
    if(sale?.sale_image) {
      setSaleImageList(sale.sale_image.split(','));
    }
    if(sale?.movie_title) {
      setMovieTitleList(sale.movie_title.split(','));
    }
    if(sale?.movie_durations) {
      setMovieTimeList(sale.movie_durations.split(','));
    }

    // 作成日
    if(sale?.created_at) {
      try {
        const date = new Date(sale.created_at);
        const formatted = `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
        setCreatedAt(formatted);
      } catch(err) {
        setCreatedAt('');
      }
    }

    // クリックカウント
    if(
      sale?.id && clickedIdList &&
      !clickedIdList.includes(sale.id)
    ) {
      // API実行
      requestApi({
        inc: '/backend/api/functions/user/sale/click_count',
        sale_id: sale.id
      }).then(resp => {
        if(resp.result == 'success') {
          // カウント済み更新
          setClickedIdList([...clickedIdList, sale.id]);
        }
      });
    }
  }, [sale])


  // シリーズの再生が変わった場合に一番上にスクロール
  // シリーズタイトル
  useEffect(() => {
    // スクロール
    if(modalRef?.current) {
      modalRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
    // シリーズタイトル
    if(
      isSeries &&
      movieTitleList && movieTitleList.length>0
    ) {
      setSeriesTitle(movieTitleList[dispIndex]);
    }
  }, [dispIndex, movieTitleList])


  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        width: '100%',
        // シリーズの場合は高さ指定しないとスクロールできない
        height: isSeries? modalHeight : 'auto',
        backgroundColor: backgroundColor,
      }}
    >

      <div
        ref={modalRef}
        style={{
          flex: 1,
          overflowY: 'auto',
          paddingBottom: isPc
            ? window.innerHeight*0.25
            : window.innerHeight*0.3,
        }}
      >

        {/* 動画/サムネ */}
        <SaleListDetailMovieThumb
          sale={sale}
          available={available}
          dispIndex={dispIndex}
          movieList={movieList}
          saleImageList={saleImageList}
        />

        <div style={{
          padding: isPc? '10px 2%' : '0px 3%',
        }}>
          {/* ラベル */}
          <SaleLabel sale={sale} />

          {/* 作成日 */}
          {createdAt &&
            <p style={{fontSize: isPc? '90%' : '80%', margin: 0}}>{createdAt}</p>
          }

          {/* 動画名 */}
          <p style={{
            fontSize: isPc? '120%' : '100%',
            fontWeight: 'bold',
            margin: seriesTitle? '5px 0 0 0' : '5px 0',
          }}>{sale?.name}</p>

          {/* シリーズタイトル */}
          {seriesTitle &&
            <p style={{
              fontSize: isPc? '120%' : '100%',
              fontWeight: 'bold',
              margin: '0 0 5px 0',
            }}>{seriesTitle}</p>
          }

          {/* 講師情報 */}
          <SaleListDetailInstructor sale={sale} />

          <div style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '10px 0px',
          }}>
            {/* お気に入り */}
            <SaleDetailFavorite sale={sale} />

            {/* 特典 */}
            <SaleDetailBenefit sale={sale} />
          </div>

          {/* シリーズ情報 */}
          {isSeries &&
            <SaleListDetailSeries
              available={available}
              dispIndex={dispIndex}
              setDispIndex={setDispIndex}
              saleImageList={saleImageList}
              movieTitleList={movieTitleList}
              movieTimeList={movieTimeList}
            />
          }

          {/* 動画説明 */}
          <SaleListDetailExplane
            sale={sale}
          />

        </div>
      </div>

      {/* 購入 */}
      {!available &&
        <SaleListDetailPurchase
          sale={sale}
        />
      }

    </div>
  );
}